import { FC, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import { getSurveyResult2 } from "../../../api/surveyQuestion.api";
import useAxios from "../../../hooks/useAxios";
import { getCommonCodeLabel } from "../../../lib/store";
import { IGetSurveyResult2, ISurveyResult2, ISurveyResultParams } from "../../../models/surveyQuestion.model";
import { RootState } from "../../../store/rootReducer";
import ErrorResponse from "../../ErrorResponse";
import Loader from "../../Loader";
import ResultSearchBar from "./ResultSearchBar";

interface IProps {
  surveyCode: number|undefined;
}

const SurveyResult2: FC<IProps> = ({
  surveyCode,
}) => {
  const { t } = useTranslation();
  const { auth, currentCampus } = useSelector((state: RootState) => state.auth);
  const { data: res, isLoading, error, execute } = useAxios<IGetSurveyResult2>();

  const [campusCode, setCampusCode] = useState('');
  const [courseCode, setCourseCode] = useState('');

  useEffect(() => {
    if (surveyCode) {
      doGetSurveyResult2();
    }
  }, [surveyCode]);

  const doGetSurveyResult2 = () => {
    if (!surveyCode) return;

    const req: ISurveyResultParams = {};
    if (auth.hqYn === 'Y') {
      if (campusCode) req.campusCode = campusCode;
    } else {
      req.campusCode = currentCampus;
    }
    if (courseCode) req.courseCode = courseCode;

    execute(getSurveyResult2(surveyCode, req));
  }

  const onSearch = () => {
    doGetSurveyResult2();
  }

  const getAverage = (data?: ISurveyResult2[]) => {
    if (!data) return '-';

    let total = 0;
    data.forEach((item) => {
      total += item.score;
    });
    return (total / data.length).toFixed(1);
  }

  return (
    <>
      {isLoading ? <Loader /> : null}
      <ErrorResponse error={error} />

      <div>
        <div className="comm-bx__between">
          <div />
          <ResultSearchBar
            campusCode={campusCode}
            setCampusCode={setCampusCode}
            courseCode={courseCode}
            setCourseCode={setCourseCode}
            onSearch={onSearch}
          />      
        </div>
        <div className="comm-table__area">
          <table>
            <thead>
              <tr>
                <th className="text-center">{t('homepage.archive.column1')}</th>
                <th className="text-center">{t('common.column.category')}</th>
                <th className="text-center">{t('common.column.title')}</th>
                <th className="text-center">{t('homepage.survey.column8')}</th>
              </tr>
            </thead>
            <tbody>
              {res?.data?.map((item, index) => (
                <tr key={index}>
                  <td className="text-center">{item.questionDetailCode}</td>
                  <td className="text-center">{getCommonCodeLabel('HP0007', item.surveyCategory, 'ko')}</td>
                  <td className="text-center">{item.title}</td>
                  <td className="text-center">{item.score.toFixed(1)}</td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan={3} className="text-center">{t('homepage.survey.column9')}</td>
                <td className="text-center">{getAverage(res?.data)}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </>
  );
}

export default SurveyResult2;
